import { APP_NAME } from "@/utils/constants";
import localforage from "localforage";
localforage.config({ name: `localforage-${APP_NAME}` });
export default localforage;
